import React, { Component } from 'react';

import Helmet from './Helmet';

const Title = 'Mercury Case Study | Canny';
const Description = 'Read about how Mercury uses Canny to improve efficiency and productivity.';
const Image = 'https://canny.io/images/468bba7765a7b99cf446df52f02c959d.jpg';

export default class ClickupLandingHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: 'https://canny.io/case-studies/mercury' },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}
      />
    );
  }
}
